import { Component, Input, OnInit } from '@angular/core';
import { Region } from 'src/app/model/region.model';
import { HelperService } from 'src/app/service/helper.service';
import { CourseHistoryService } from '../../service/course-history.service';
import { CourseHistory, EditableCourseHistory } from './model/course-history';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { AccessService } from 'src/app/component/navigation/service/access.service';

import { CourseType } from 'src/app/model/course-type';

import { TermType } from 'src/app/model/term-type';
import { CourseHistorySchoolEnrollments } from './model/course-history-school-enrollments';
import { StudentHelperService } from '../../service/student-helper.service';
import { Student } from 'src/app/model/student/student.model';
import { SearchStudent } from '../../model/searchStudent';

const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
    arr.reduce((groups, item) => {
        (groups[key(item)] ||= []).push(item);
        return groups;
    }, {} as Record<K, T[]>);

@Component({
    selector: 'app-course-history',
    templateUrl: './course-history.component.html',
    styleUrls: ['./course-history.component.scss']
})
export class CourseHistoryComponent implements OnInit {
    @Input() studentId: number;
    @Input() editing: boolean;

    lstCourseHistory: EditableCourseHistory[] = [];
    lstRegionbyGroup: Array<any> = [];
    userRegion: Region;
    searchStudent: SearchStudent;
    boolFoundCourseHistory: boolean = true;
    addAccess: boolean = false;
    isLoading: boolean = true;
    studentName:string=''; 
    constructor(
        public studentHelperService: StudentHelperService,
        public helperService: HelperService,
        public courseHistoryService: CourseHistoryService,
        public accessService: AccessService
    ) {}

    ngOnInit(): void {
        this.accessService.featureAccessible('Create Course Histories').subscribe((x) => {
            if (x) {
                this.addAccess = x;
            }
        });
        this.subscriptions();
        this.invokeApiGetCourseHistory('');
        this.accessService.loadCourseSection();
        this.accessService.loadCourseType();
        this.accessService.loadTermType();

    }

    ngOnChanges(): void {
        if (this.editing == false) this.invokeApiGetCourseHistory('cancelled');
    }

    subscriptions() {
        this.studentHelperService.studentName$.subscribe((studentName) => {
            this.studentName = studentName;
        });

        this.studentHelperService.searchStudent$.subscribe((sStudent) => {
            this.searchStudent = sStudent;
        });
        this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
            this.userRegion = userRegion[0];
        });
    }

    invokeApiGetCourseHistory(action: string) {
        if (action == 'cancelled') {
            this.lstCourseHistory = this.lstCourseHistory.filter((u: EditableCourseHistory) => u.courseHistory.ID !== -1);
            this.groupbyRegionCode();
        } else {
            this.courseHistoryService.getCourseHistory(this.studentId.toString()).subscribe((x) => {
                if (x['msg'] !== undefined) {
                    this.lstCourseHistory = [];
                } else {
                    this.lstCourseHistory = [];
                    let y: CourseHistory[] = JSON.parse(x['courseHistories']);

                    y.forEach((element) => {
                        element.CREATED_DATE = new CleanDatePipe().transform(element.CREATED_DATE!);
                        this.lstCourseHistory.push({ isEdit: false, courseHistory: element, isDelete: false });
                    });
                    const now = new Date().getTime();

                    this.lstCourseHistory.sort((a, b) => {
                        return (
                            (b.courseHistory.CREATED_DATE ? b.courseHistory.CREATED_DATE!.getTime() : now) -
                            (a.courseHistory.CREATED_DATE ? a.courseHistory.CREATED_DATE!.getTime() : now)
                        );
                    });
                }
                this.groupbyRegionCode();
            });
        }
    }

    groupbyRegionCode() {
        this.lstRegionbyGroup = [];
        const record = groupBy(this.lstCourseHistory, (i) => i.courseHistory.REGION.CODE);
        Object.keys(record).map((key) => {
            let a: EditableCourseHistory[] = record[key];
            this.lstRegionbyGroup.push({ id: key, editableCH: a });
        });

        this.boolFoundCourseHistory = this.lstRegionbyGroup.length > 0 ? true : false;
        this.isLoading = false;
    }

    addRow() {
        if (this.editing) {
            this.lstCourseHistory.findIndex((x) => x.isEdit == true) == -1
                ? (this.lstCourseHistory = [{ isEdit: true, isDelete: false, courseHistory: this.buildStudentCourseHistory() }, ...this.lstCourseHistory])
                : null;
            this.groupbyRegionCode();
        }
    }
    buildStudentCourseHistory(): CourseHistory {
        const arrPCMId = this.toNumberArray(this.lstCourseHistory);
        let min = arrPCMId.length > 0 ? arrPCMId.reduce((a, b) => Math.min(a, b)) : 0;
        min = min > 0 ? -1 : min - 1;

        let tempCH = new CourseHistory();
        tempCH.ID = min;
        tempCH.STUDENTS_ID = this.studentId;
        //tempCH.REGION = this.searchStudent.REGIONS[0];
        tempCH.REGION = this.userRegion
        
        //tempCH.SCHOOL_ENROLLMENT=new CourseHistorySchoolEnrollments();
        tempCH.SCHOOL_YEAR = '';
        tempCH.SCHOOL_ENROLLMENTS_ID = 0;
        tempCH.COURSE_TITLE = '';
        tempCH.SUBJECT_TITLE = '';
        //tempCH.COURSE_TYPE=new CourseType();
        //tempCH.TERM_TYPE =new TermType();
        tempCH.CLOCK_HOURS = '';
        tempCH.CREDITS_GRANTED = '';

        return tempCH;
    }

    toNumberArray(array: EditableCourseHistory[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.courseHistory.ID ? returnArray.push(obj.courseHistory.ID) : null;
        });

        return returnArray;
    }
}
